export default __webpack_public_path__ + "static/media/SamoDevil.62210dfd.png";